import { useContext } from 'react'
import { ConfirmContext } from 'sutra/components/confirm/confirm-context'
import type { ConfirmFn } from 'sutra/components/confirm/confirm-types'

export const useConfirm = (): ConfirmFn => {
  const confirm = useContext(ConfirmContext)
  if (!confirm) {
    throw new Error('useConfirm must be used inside a <ConfirmProvider>')
  }
  return confirm
}
